<template>
  <div class="comments-container">
    <comments-item v-for="comment in comments" :key="comment.id" :comment="comment" />
  </div>
</template>

<script>
import CommentsItem from './comments-item'

export default {
  components: {
    'comments-item': CommentsItem
  },
  props: ['comments']
}
</script>

<style lang="less">
.comments-container {
  max-height: 50vh;
  overflow: auto;
}
</style>
